import api from 'axios'

export default {
  getMerchantById: async (id) => (await api.get(`/v1/discover/web/merchant/${id}`)).data,
}
